import { render, staticRenderFns } from "./tablePositionsHead.vue?vue&type=template&id=8150af6a&"
import script from "./tablePositionsHead.vue?vue&type=script&lang=js&"
export * from "./tablePositionsHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports